export const USERS_STATS = {
  HEADING: "عملاء وفّي",
  CLIENT_ADMIN_HEADING: "عملاء {{val, string}} في وفّي",
  ACTIVE_USER: "العملاء المفعلين",
  INACTIVE_USER: "العملاء الغير مفعلين",
  TOTAL_USER: "عدد العملاء",
};
